import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';

export type BulkUpdateUsersWeeklyReportOptions = {
  onSuccess?: () => void;
};

export type BulkUpdateUsersWeeklyReportParams = {
  userIds: number[];
  weeklyReportEnabled: boolean;
};

export const bulkUpdateUsersWeeklyReport = async (
  userIds: number[],
  weeklyReportEnabled: boolean
) => {
  return await EXPRESS_API.patch(`/users/weekly-report`, {
    userIds,
    weeklyReportEnabled,
  });
};

export const useBulkUpdateUsersWeeklyReportStatusMutation = (
  onSuccess?: () => void
) => {
  const { t } = useTranslation();
  const { showError } = useToastError();

  return useMutation(
    ({ userIds, weeklyReportEnabled }: BulkUpdateUsersWeeklyReportParams) =>
      bulkUpdateUsersWeeklyReport(userIds, weeklyReportEnabled),
    {
      onSuccess: (_, variables) => {
        onSuccess?.();
        const count = variables.userIds.length;
        successToast({
          title: t(
            'Report settings updated successfully for {{count}} user{{suffix}}',
            {
              count,
              suffix: count === 1 ? '' : 's',
            }
          ),
        });
      },
      onError: () => {
        showError({
          title: t(
            'There was an error updating report settings. Please try again.'
          ),
        });
      },
    }
  );
};
